import React from "react";
import ModalWrapperChildren from '@/views/components/Modal/ModalWrapperChildren';
import { useSelector } from 'react-redux';

import styles from '@/views/pages/SimpleText/SimpleText.module.scss';

const ModalTips = ({ showModalTips, setShowModalTips}) => {
	const { dict } = useSelector((state) => state.app);

	return (
		<ModalWrapperChildren 
			onClose={ () => setShowModalTips(false) }
			setModalVisible={ setShowModalTips }
			modalVisible={ showModalTips }
			onConfirm={ () => setShowModalTips(false) }
			confirmButtonName={ dict.close }
			title={ dict.simpletext.tips.title }
		>		
			<p className={ styles['simple-text__list-title'] }>{ dict.simpletext.tips.part1 }</p>
			<ol className= { styles['simple-text__list'] }>
				<li>{ dict.simpletext.tips.part2 }</li>
				<li>{ dict.simpletext.tips.part3 }</li>
				<li>{ dict.simpletext.tips.part4 }</li>
				<li>{ dict.simpletext.tips.part5 }</li>
				<li><strong>{ dict.simpletext.tips.part6 }</strong>{ dict.simpletext.tips.part7 }</li>
				<p>{ dict.simpletext.tips.part8 }</p>
				<li>{ dict.simpletext.tips.part9 }</li>
				<li>{ dict.simpletext.tips.part10 }</li>
			</ol>
		</ModalWrapperChildren>
	);
};

export default ModalTips;
